export default {
    devices: [
        { id: 'ios_phone', title: 'Смартфон iOS', checked: false },
        { id: 'ios_tablet', title: 'Планшет iOS', checked: false },
        { id: 'android_phone', title: 'Смартфон Android', checked: false },
        { id: 'android_tablet', title: 'Планшет Android', checked: false },
    ],
    days: [
        { id: 'monday', title: 'Понедельник', checked: false },
        { id: 'tuesday', title: 'Вторник', checked: false },
        { id: 'wednesday', title: 'Среда', checked: false },
        { id: 'thursday', title: 'Четверг', checked: false },
        { id: 'friday', title: 'Пятница', checked: false },
        { id: 'saturday', title: 'Суббота', checked: false },
        { id: 'sunday', title: 'Воскресенье', checked: false },
    ]
}
